import Vue from 'vue'
import App from './App.vue'

Vue.config.silent = true
Vue.config.productionTip = false

// Plugins.
import './plugins/bootstrap-vue'
import './plugins/vee-validate'
import './plugins/vue-mask'

// Configs.
import './configs'

// Repositories,
import repositories from './repositories'

// Routers.
import router from './router'

// Store.
import store from './store'

new Vue({
    provide: { repositories },
    router,
    store,
    render: h => h(App),
}).$mount('#app')
